module.exports = __webpack_public_path__ + "img/leveler-5-on.d877241b.png";